function menuClicker() {
  
  let menuitemsmain = document.querySelectorAll('.c-menu__list__link--primary');  
  
  if(menuitemsmain) {

    function clearMenuFocus() {
      menuitemsmain.forEach( (mitem)=>{
        mitem.classList.remove('active');
      });
    }
    
    menuitemsmain.forEach( (mitem)=>{
      
      mitem.addEventListener('click',()=>{
        clearMenuFocus();
        mitem.classList.add('active');
      })     
      
    })
    
  }

}


function hotspotReadyListener() {

  // console.log('hsready');

  setTimeout( ()=>{
    hotspotDotMapShow();
    hotspotMapArrows();
  }, 2000)
  
}

function hotspotDotMapShow() {

  // console.log('showdots');

  let hasmap = document.querySelectorAll('.simple_banner_slider');
  let hasbanner = document.querySelectorAll('.dotbanner-');

  if(hasmap.length || hasbanner.length) {
    let sliderDots = document.querySelectorAll('.dotslider-icon');
    let bannerDots = document.querySelectorAll('.dotbanner-icon');
    sliderDots.forEach( (theDot)=>{
      theDot.classList.add('active');
    })
    bannerDots.forEach( (theDot)=>{
      theDot.classList.add('active');
    })
  }
  
}

function hotspotMapArrows() {

  // console.log('showarrows');

  let hasmap = document.querySelectorAll('.simple_banner_slider');

  if(hasmap.length) {
    console.log('has length');
    hasmap.forEach( (eachHSmap) => {
      console.log('each');
      hsMapSlides = eachHSmap.querySelectorAll('.swiper-slide')
      if(hsMapSlides.length > 1) {
        console.log('has more than 1');
        let arrowLeft = eachHSmap.querySelector('.swiper-button-prev');
        let arrowRight = eachHSmap.querySelector('.swiper-button-next');
        if(arrowLeft || arrowRight) {
          arrowLeft.classList.add('active');
          arrowRight.classList.add('active');
        }
      }
    });
  }
  
}


document.addEventListener("DOMContentLoaded", function(event) { 
  menuClicker();
  hotspotReadyListener();
});